import {makeForgotPasswordValidateToken} from 'main/factories/usecases';
import {VerifyForgotPasswordTokenParams} from './types';

export async function verifyForgotPasswordToken({
	signal,
	...tokenParams
}: VerifyForgotPasswordTokenParams) {
	const response = await makeForgotPasswordValidateToken().validateToken({
		signal,
		...tokenParams,
	});

	return response;
}
